module.exports = __webpack_public_path__ + "static/media/bgr-one-md.0a0090c2.webp";